import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import '../styles/footer.css';


const Footer = () => {
  const { theme } = useTheme();

  return (
    <footer className="footer-wrapper">
      <div className="footer-grid">
        {/* Column 1: Brand Info & Socials */}
        <div className="footer-column">
          <div className="footer-logo-container">
            <Link to="/" className="footer-brand">
              <img src={theme === 'light' ? '/RegardTraderLogo_black.png' : '/RegardTradersLogo.png'} alt="REGARD TRADERS" className="footer-logo-img" />
            </Link>
          </div>
          <p className="footer-text">
            Your trusted wholesale partner for premium products.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h3 className="footer-column-title">Quick Links</h3>
          <ul className="footer-links-list">
            <li>
              <Link to="/#home-top" className="footer-link">Home</Link>
            </li>
            <li>
              <Link to="/#shop-sections" className="footer-link">Sections</Link>
            </li>
            <li>
              <Link to="/#popular-categories" className="footer-link">Categories</Link>
            </li>
            <li>
              <Link to="/shop" className="footer-link">All Products</Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Help & Support */}
        <div className="footer-column">
          <h3 className="footer-column-title">Help & Support</h3>
          <ul className="footer-links-list">
            <li>
              <Link to="/about" className="footer-link">About Us</Link>
            </li>
            <li>
              <Link to="/return" className="footer-link">Return Policy</Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </li>
            <li>
              <Link to="/shipping" className="footer-link">Shipping Policy</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright Bottom Bar */}
      <div className="footer-bottom">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} REGARD TRADERS. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;

